<h1>DE CIFRIS TRENDS IN MODERN CRYPTOGRAPHY<br>THE FRENCH MAGISTERIUM</h1>
<div class="toptext">
	<p>
		Not only many Italian cryptographers have joined our association "De Componendis Cifris", but also many
		other EU citizens, such as academics, students, professionals.
	</p>
	<p>
		Among the many purposes of the association, there is support for the study and research in cryptography;
		therefore, it also promotes and coordinates educational and dissemination activities. <br>
		With this in mind, every year the association promotes a new course within the "Trends in Modern
		Cryptography Series" (a similar course was held in <a routerLink="/trends23">2023</a> and in <a
			routerLink="/trends22">2022</a>).
	</p>
	<p>
		This year we will have a special course in this series, <b>"Trends in Modern Cryptography: the French
			magisterium"</b>.<br>
		This course introduces methods and techniques used in cryptography, in a broad sense (theory/applications,
		design/protocols, etc), with the help of twenty excellent French cryptographers. We strongly believe in the
		cooperation between France and Italy to strengthen European cryptography: this course is an important step
		in this direction.
	</p>

	<p>
		The course is particularly well suited for MSC students interested in cryptography. We especially welcome
		Italian and French students, but also any other nationality is welcome. <br>
		We expect not only students to attend our course, but also anyone familiar with standard cryptography and
		its mathematical background can attend this course, including Ph.D. students, MSC graduates, and
		professionals working for companies or for the public sector.
	</p>
	<div class="image-container">
		<img mat-card-image src="../../../../assets/images/icons/decifris.svg" style="height: 50px;">
		<img mat-card-image src="../../../../assets/images/logos/unitn.png" style="height: 80px;">
	</div>
</div>
<!-- img style="width: 40vw" src="../../../assets/attivita/Trends23/locandina-Trends-23.png" 
			class="rounded mx-auto d-block" alt="..."-->
<!-------------------------------------------------------------------->


<h2>GENERAL INFORMATION</h2>
<div class="text">
	<h3>Organizers</h3>
	<p>
		Alessio Meneghetti (UNITN) and Sihem Mesnager (Paris VIII).
	</p>

	<h3>Lecturers</h3>

	<p>
		Magali Bardet (University of Rouen, France).
		Sonia Belaïd (CryptoExperts, Paris, France).
		Jean-Francois Biasse (Center for Cryptographic Research, USF, USA).
		Christina Boura (University of Versailles, France).
		Sébastien Canard (Telecom Paris- Saclay, France).
		Anne Canteaut (INRIA Paris, France).
		Claude Carlet (Universities of Bergen and Paris 8, France).
		Léo Ducas (Centrum Wiskunde Informatica (CWI), Amsterdam, Netherlands)
		Thomas Debris-Alazard (INRIA Paris, France).
		Louis Goubin (University of Versailles, France).
		Adeline Roux-Langlois (GREYC, CNRS, Unicaen, Ensicaen, Caen, France).
		Alice Pellet-Mary (University of Bordeaux, France).
		Sihem Mesnager (Universities of Paris VIII and Sorbonne North, France).
		Pierrick Meaux (University of Luxembourg, Luxembourg).
		Ludovic Perret (University of Paris VII, France).
		Léo Perrin (INRIA Paris, France) .
		Damien Stehlé (ENS Lyon, France).
		Serge Vaudenay (EPFL Switzerland).
		Damien Vergnaud (Sorbonne University, France).
		Giles Zémor (University of Bordeaux, France).
	</p>
	<h3> Course structure </h3>
	<p>
		TThe course is divided into twenty online lectures, made available to all participants via YouTube. The lessons are held in English and take place
		at 5:00 PM in September, October and
		November 2024. The lectures are recorded and available to all <b>participants</b> of the course.
		The recorded lectures will be open to everyone a few months <b>after</b> the course, that is,
		in early 2025.
	</p>

	<h3> Course prerequisites </h3>
	<ul style="list-style-type:none;  padding-left: 0;">
		<li>
			Mathematics: basic concepts of computational complexity, elementary number theory and
			probability theory.
		</li>

		<li>
			Symmetric cryptography: basic understanding of block ciphers, stream ciphers, hash functions and
			MAC's.
		</li>

		<li>
			Public-key cryptography: DH and RSA.
		</li>

		<li>
			Protocols: some general concept on protocols, such as those necessary to understand SSL/TLS.
		</li>
	</ul>

	<h3> Registration and costs </h3>
	<p>
		The course is free of charge, and any De Cifris member can attend. Registration is open until the end of
		October 2024 or until the maximum number of attendees (five hundred) is reached. For any further
		information about the registration, write to <a href="mailto:trends@decifris.it">trends&#64;decifris.it</a>.
	</p>
</div>
<!-------------------------------------------------------------------->

<h2>COURSE PROGRAM</h2>
<div class="row">
	<div class="col-md-12" style="margin-right:5% !important">
		<table class="table table-striped">
			<thead>
				<tr>
					<th scope="col" style="width: 5%;"> Date </th>
					<th scope="col" style="width: 50%;"> Subject </th>
					<th scope="col" style="width: 5%;"> Time </th>
					<th scope="col" style="width: 40%;"> Lecturer </th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th scope="row">
						Sep 30
					</th>
					<td>
						The Almost Perfect Nonlinearity of Substitution Boxes and its Consequences <br>
						<a href="https://drive.google.com/file/d/193Ff7RTrUIze9VhrKx7CwKbwYK09ShCl" target="_blank">
							Slides </a>
						<!-- <a href="https://youtu.be/XOWFT8qoWjo?si=4vqySWSs2PIIVHv7">YT video</a>-->
					</td>
					<td>
						17:00
					</td>
					<td>
						Claude Carlet
						<br>
						(Universities of Bergen and Paris 8, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 03
					</th>
					<td>
						Algebraic aspects in designing cryptographic functions in symmetric
						cryptography <br>
						<a href="https://drive.google.com/file/d/1sLIGLQIBVeDIHFgJ22nCwOzsBUbNTKgI" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Sihem Mesnager
						<br>
						(Universities of Paris VIII and Sorbonne North, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 07
					</th>
					<td>
						Lightweight symmetric primitives <br>
						<a href="https://drive.google.com/file/d/11gkx4QXfALY57zzoWOdTP7QV7c2yfo9C" target="_blank">
							Slides </a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Anne Canteaut
						<br>
						(INRIA Paris, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 10
					</th>
					<td>
						Symmetric Techniques for Advanced Protocols: Design Strategies, and
						Cryptanalysis <br>
						<a href="https://drive.google.com/file/d/14jkOrjm_Gb_R5if_-fSoCbHPnqcKGKyC" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Léo Perrin
						<br>
						(INRIA Paris, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 14
					</th>
					<td>
						The Transition to Post-Quantum Cryptography <br>
						<a href="https://drive.google.com/file/d/1HKNTiOcO12jdcXOBDJ5CdhkTp0M5twls" target="_blank">
							Slides </a>
					</td>
					<td>
						17:00
					</td>
					<td>
						Ludovic Perret
						<br>
						(University of Paris VII, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 17
					</th>
					<td>
						Lattice-based Cryptography (I) <br>
						<a href="https://drive.google.com/file/d/1XLdZXBBPp6lUnGf9YesILcKTORd-AaIz" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Léo Ducas
						<br>
						(Centrum Wiskunde Informatica (CWI), Amsterdam, Netherlands)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 21
					</th>
					<td>
						Lattice-based Cryptography (II) <br>
						<a href="https://drive.google.com/file/d/1DOWiMOeFQeb5XPvXcSn8s_UjzTNUGLpg" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Alice Pellet-Mary <br>
						(University of Bordeaux, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 24
					</th>
					<td>
						Hardness of the Module Learning With Errors Problem<br>
						<a href="https://drive.google.com/file/d/1DMYH25rkSc9GhKDRqsqGwazfQMcpROnJ/view"
							target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Adeline Roux-Langlois <br>
						(GREYC, CNRS, Unicaen, Ensicaen, Caen, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 28
					</th>
					<td>
						Diving into Multivariate Cryptography <br>
						<a href="https://drive.google.com/file/d/1mdeQJIGNXOP0jINnMlgj0LfThjMx2zgu" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td> Louis Goubin <br>
						(University of Versailles, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Oct 31
					</th>
					<td>
						The Code Equivalence Problem and its Applications to Cryptography <br>
						<a href="https://drive.google.com/file/d/1ofF5N6znXT-rD1-G7Lz3ybksWMo3zeE1" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Jean-Francois Biasse
						<br>
						(Center for Cryptographic Research, USF, USA)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 04
					</th>
					<td>
						Code-based Cryptography<br>
						<a href="https://drive.google.com/file/d/1MpCka1WcQJ8LFx1IRT8xZwjW0dY5c-Ps" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Thomas Debris-Alazard
						<br>
						(INRIA Paris, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 07
					</th>
					<td>
						The Alekhnovich cryptosystem: code-based cryptography with security
						proofs<br>
						<a href="https://drive.google.com/file/d/1JbIMAigENCS6Chizw5Nfsc8hUKWhktEc" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Giles Zémor
						<br>
						(University of Bordeaux, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 11
					</th>
					<td>
						Multi-Party Computation in the Head: Techniques and Applications<br>
						<a href="https://drive.google.com/file/d/1MUWiTTGelfUjS_Kst5wyOLS87hYlzyCt" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Damien Vergnaud
						<br>
						(Sorbonne University, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 14
					</th>
					<td>
						Polynomial System Solving and Application to Algebraic Cryptanalysis<br>
						<a href="https://drive.google.com/file/d/1xVUxoaNO3mwsagu60eq8MI1HrlYpSOIm" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Magali Bardet
						<br>
						(University of Rouen, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 18
					</th>
					<td>
						Tools for cryptanalysis of symmetric primitives<br>
						<a href="https://drive.google.com/file/d/1UjHLKnwD803AvwA-Vk4f_h1TMZwjBpG0" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Christina Boura
						<br>
						(University of Versailles, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 21
					</th>
					<td>
						Side-Channel Attacks and Masking Countermeasures<br>
						<a href="https://drive.google.com/file/d/13WG16165bWNcYc41F2cG8-7ZD5h8fOTm" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Sonia Belaïd
						<br>
						(CryptoExperts, Paris, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 25
					</th>
					<td>
						Fully Homomorphic Encryption<br>
						<a href="https://drive.google.com/file/d/16XTPnchrQ5weoM41skfiVvWfjMxkxww9" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Damien Stehlé
						<br>
						(ENS Lyon, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Nov 28
					</th>
					<td>
						Hybrid Homomorphic Encryption<br>
						<a href="https://drive.google.com/file/d/1G83ylD_pB1lfMd32_D82q_lf2rrirti9" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Pierrick Meaux
						<br>
						(University of Luxembourg, Luxembourg)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Dec 02
					</th>
					<td>
						Cryptography for anonymity and accountability<br>
						<a href="https://drive.google.com/file/d/1xh6fmcv7N5rKTdiWQKWuFlzUiiVcCLXC" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Sébastien Canard
						<br>
						(Telecom Paris- Saclay, France)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Dec 05
					</th>
					<td>
						Anonymous Tokens<br>
						<a href="https://drive.google.com/file/d/1nbDpBfWT15uBrI_WPvKCkr8k9c6SDHPj" target="_blank">
							Slides </a>

					</td>
					<td>
						17:00
					</td>
					<td>
						Serge Vaudenay
						<br>
						(EPFL Switzerland)
					</td>
				</tr>
				<tr>
					<th scope="row">
						Dec 09
					</th>
					<td>
						Trends 24 - Recap and Concluding Remarks
					</td>
					<td>
						17:00
					</td>
					<td>
						Sihem Mesnager
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<h2> EXAMINATION </h2>
<div class="text">
	<p>
		The participants who pass an online test <b>in late January 2025</b> will receive a &quot;Course
		Attendance&quot;
		certificate. The test consists of a written essay with personalized questions to be completed online in
		one hour.
	</p>
</div>

<h2>INFORMATION FOR ENROLLED STUDENTS</h2>
<div class="text">
		<p>
			Please forward any question about the lectures either to <a
				href="mailto:trends@decifris.it">trends&#64;decifris.it</a> or to <a
				href="mailto:alessio.meneghetti@unitn.it">alessio.meneghetti&#64;unitn.it</a>.
		</p>
</div>